import React, { useState, useEffect } from 'react';
import { Placing, PlayerOwnership } from '../../types/types';
import PlayerDataGrid from '../DataGrid/PlayerDataGrid';
import RoundSelector from '../Inputs/RoundSelector';
import { BuildPlayerOwnershipTable, PlayerOwnershipTableColumns } from '../../globals/TableFunctions';
import TableContainer from '../Tables/TableContainer';
import { CompletedRounds } from '../../globals/BBLData';
import SingleRoundHeading from './SingleRoundHeading';
import styled from '@emotion/styled';
import { useAppDispatch } from '../../hooks';
import { getSingleRoundOwnership } from '../../state/reducers/SCTeamsReducer';
import { useParams } from 'react-router-dom';
const HeaderContainer = styled.div`
    display: flex;
    column-gap: 1rem;
    @media(max-width: 800px) {
        flex-direction: column;
        row-gap: 1rem;
        margin-bottom: 1rem;
    }
`;

export interface Props {
    playerOwnerships: PlayerOwnership[];
    placings: Placing[];
}
const PlayerOwnershipsContainer = ({playerOwnerships,placings}: Props) => {
    const dispatch = useAppDispatch();
    let { teamid } = useParams<{teamid:string}>();
    const [ playerOwnershipRows, setPlayerOwnershipRows] = useState([]);
    const [ selectedPo, setSelectedPo ] = useState(playerOwnerships[0]);
    const [ selectedRound, setSelectedRound ] = useState(CompletedRounds[CompletedRounds.length-1]);
    const [ selectedPlacing, setSelectedPlacing] = useState(placings[placings.length - 1]);
    
    useEffect(() => {
        setPlayerOwnershipRows(BuildPlayerOwnershipTable(selectedPo));
    },[selectedPo])

    function onChange(e) {
        let found:boolean = false;
        setSelectedRound(e.target.value);
        playerOwnerships.map(function(po) {
            if (po.round === e.target.value) {
                setSelectedPo(po);
                found = true;
            }
        });
        
        placings.map(function(placing) {
            if (placing.round === e.target.value) {
                setSelectedPlacing(placing);
            }
        });
        if (!found && selectedPlacing) {
            dispatch(getSingleRoundOwnership({teamid: teamid, round: e.target.value}));
        }
    }

    function BuildSelectedPO(round:number) {
        let found:boolean = false;
        playerOwnerships.map(function(po) {
            if (po.round === round) {
                setSelectedPo(po);
                found = true;
            }
        });
        placings.map(function(placing) {
            if (placing.round === round) {
                setSelectedPlacing(placing);
            }
        });

        if (!found && selectedPlacing) {
            dispatch(getSingleRoundOwnership({teamid: teamid, round: round}));
        }
    }

    useEffect(() => {
        BuildSelectedPO(selectedRound);
    },[playerOwnerships])
    
    return (<TableContainer
            header={"Player Ownerships"}
        >
            <HeaderContainer>
                <RoundSelector 
                    onChange={onChange}
                    selectedRound={selectedRound}  
                    availableRounds={playerOwnerships.map(function(po){ return po.round})}
                />
                <SingleRoundHeading placing={selectedPlacing} playerOwnership={selectedPo} />
            </HeaderContainer>
            <PlayerDataGrid 
                columns={PlayerOwnershipTableColumns}
                rows={playerOwnershipRows}
                height={800}
                onCellClick={e => console.log("e")}
            />
        </TableContainer>)

}
export default PlayerOwnershipsContainer;